import { z } from '@harvestiq/zod';
import { legacySequelizeUserSchema } from './shared';

export const updateUserRequestSchema = z.object({
  firstName: z.string().trim().optional(),
  lastName: z.string().trim().optional(),
  email: z.string().trim().toLowerCase().email().optional(),
  confirmedAt: z.coerce.date().nullable().optional(),
  timezone: z.string().trim().optional(),
});
export type UpdateUserRequest = z.infer<typeof updateUserRequestSchema>;

export const updateUserSuccessResponseSchema = z.object({
  user: legacySequelizeUserSchema,
});
export type UpdateUserSuccessResponse = z.infer<
  typeof updateUserSuccessResponseSchema
>;

export const updateUserErrorResponseSchema = z.object({
  // TODO: errors object should be an array not string but matching existing API patterns
  errors: z.array(z.string()).or(z.string()),
});
export type UpdateUserErrorResponse = z.infer<
  typeof updateUserErrorResponseSchema
>;

export const updateUserResponseSchema = updateUserSuccessResponseSchema.or(
  updateUserErrorResponseSchema
);
export type UpdateUserResponse = z.infer<typeof updateUserResponseSchema>;
